import { useRef, useState } from "react";
import { PosterContent } from "@/components/PosterCanvas";
import { uploadSnapshot } from "@/lib/renderPoster";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Loader2, Radio, PowerOff } from "lucide-react";

const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export const LiveToggle = ({ poster, online, onOn, onOff }) => {
  const [busy, setBusy] = useState(false);
  const [render, setRender] = useState(false);
  const ref = useRef(null);

  const goOnline = async () => {
    setBusy(true);
    try {
      if (!poster.snapshot_url) {
        setRender(true);
        await wait(300);
        await uploadSnapshot(api, poster.id, ref.current, 720, "tv").catch(() => {});
        setRender(false);
      }
      await onOn(poster);
    } finally {
      setBusy(false);
    }
  };
  const goOffline = async () => {
    setBusy(true);
    try { await onOff(poster); } finally { setBusy(false); }
  };

  return (
    <>
      <Button size="sm" variant={online ? "outline" : "default"} disabled={busy} onClick={online ? goOffline : goOnline}
        className={`w-full ${online ? "border-red-500/60 text-red-400 hover:bg-red-500/10 hover:text-red-300" : "bg-emerald-600 text-white hover:bg-emerald-500"}`}
        data-testid={`live-toggle-${poster.id}`}>
        {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : online ? <PowerOff className="mr-1 h-4 w-4" /> : <Radio className="mr-1 h-4 w-4" />}
        {online ? "Mettre hors ligne" : "Mettre en ligne"}
      </Button>
      {render && (
        <div style={{ position: "fixed", left: -20000, top: 0, width: 1280, pointerEvents: "none", zIndex: -1 }} aria-hidden="true">
          <div ref={ref} style={{ width: 1280, height: 720 }}><PosterContent data={poster} editable={false} /></div>
        </div>
      )}
    </>
  );
};
